/** Public B2C registration of the current document/knowledge features.
 * Does not import the enterprise application, tenant bootstrap or Knox SSO.
 */
import { lazy } from 'react';
import {
  setDocAgentModePageComponent,
  setDocAgentLandingPageComponent,
  setDocAgentEditorPageComponent,
  setMemoryModePageComponent,
  setTranslationModePageComponent,
} from '@auw/workspace-features';
import {
  setDocxPreviewRendererComponent,
  setSpecializedStorageComponents,
  setWikiSourcePickerComponent,
} from '@auw/workspace-ui';

export function registerB2cFeatures(): void {
  setDocAgentModePageComponent(lazy(() => import('./features/modes/doc-agent/DocAgentModePage')));
  setDocAgentLandingPageComponent(lazy(() => import('./features/modes/doc-agent/DocAgentModePage')
    .then(m => ({ default: m.DocAgentLandingRoutePage }))));
  setDocAgentEditorPageComponent(lazy(() => import('./features/modes/doc-agent/DocAgentModePage')
    .then(m => ({ default: m.DocAgentEditorRoutePage }))));
  setDocxPreviewRendererComponent(lazy(() => import('./features/docAgent/pagedEditor/DocxPreviewRenderer')
    .then(m => ({ default: m.DocxPreviewRenderer }))));
  setSpecializedStorageComponents('doc-agent', {
    Tree: lazy(() => import('./features/docAgent/components/landing/DocStorageTree').then(m => ({ default: m.DocStorageTree }))),
    List: lazy(() => import('./features/docAgent/components/landing/DocStorageList').then(m => ({ default: m.DocStorageList }))),
  });
  setWikiSourcePickerComponent(lazy(() => import('./features/docAgent/components/landing/DocAgentWikiSourcePicker')
    .then(m => ({ default: m.DocAgentWikiSourcePicker }))));
  setMemoryModePageComponent(lazy(() => import('./features/memory/MemoryPage').then(m => ({ default: m.MemoryPage }))));
  setTranslationModePageComponent(lazy(() => import('./features/translation/TranslationPage').then(m => ({ default: m.TranslationPage }))));
}
